import React from "react";
import NavigationLinks from "./NavigationLinks";
import "../css/main-header.css";
import ComponentContainer from "./ComponentContainer";
import MyLink from "./MyLink";
import { independentPaths, paths } from "../paths";
import { useLocation } from "react-router-dom";
import userStore from "../store/userStore";
import { ReactComponent as CircleSvg } from "../assets/svg/Ellipse 1.svg";
import "../css/media-main-header.css";
import MainOffcanvas from "./MainOffcanvas";

const MainHeader = () => {
  const location = useLocation();
  return (
    <header>
      <div className="header-container">
        <div className="main-header-navigation-links">
          <MainOffcanvas
            head={
              <div className="online">
                <div className="online-dot">
                  <CircleSvg />
                  Онлайн: <span className="online-count">1000</span>
                </div>
              </div>
            }
            className="main-header resp-md"
          >
            <MyLink
              to={paths.Main}
              className={`link ${
                location.pathname === userStore.choosedServerUrl + paths.Main
                  ? "active"
                  : ""
              }`}
            >
              ИГРАТЬ
            </MyLink>
            <MyLink
              to={paths.Main}
              className={`link ${
                location.pathname === userStore.choosedServerUrl + paths
                  ? "active"
                  : ""
              }`}
            >
              О НАС
            </MyLink>
            <MyLink
              to={paths.Main}
              className={`link ${
                location.pathname === userStore.choosedServerUrl + paths
                  ? "active"
                  : ""
              }`}
            >
              МЕГАШОП
            </MyLink>
            <MyLink
              to={paths.Main}
              className={`link ${
                location.pathname === userStore.choosedServerUrl + paths
                  ? "active"
                  : ""
              }`}
            >
              МЕГАПРОФИЛЬ
            </MyLink>
            <MyLink
              to={paths.Main}
              className={`link ${
                location.pathname === userStore.choosedServerUrl + paths
                  ? "active"
                  : ""
              }`}
            >
              ИВЕНТЫ
            </MyLink>
            <MyLink
              to={paths.Main}
              className={`link ${
                location.pathname === userStore.choosedServerUrl + paths
                  ? "active"
                  : ""
              }`}
            >
              ГИЛЬДИИ
            </MyLink>
          </MainOffcanvas>
        </div>
      </div>
    </header>
  );
};

export default MainHeader;
